var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62985 14.6823C0.979703 7.70504 6.19317 2.21202 12.3427 1.63634C19.3201 0.983295 24.749 6.20256 25.3629 12.3307C26.0566 19.2556 20.7688 24.826 14.6646 25.3709C7.71856 25.9909 2.20196 20.823 1.62985 14.6823ZM12.5566 0.0412845C9.63421 0.281443 7.36983 1.21446 5.21207 2.85019C3.38708 4.23367 1.79222 6.34243 0.897927 8.66086C-2.56002 17.6246 4.3943 27.7073 14.48 26.9609C25.151 26.1712 30.7712 13.9539 24.1544 5.21228C21.5794 1.81047 17.05 -0.327942 12.5566 0.0412845Z",
    fill: "#065697"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3266 17.5083C14.6078 17.5124 13.0279 16.4095 12.555 16.0509C11.3298 15.1219 10.4328 13.9269 9.7093 12.5674C9.22891 11.6644 9.43913 11.7853 10.1809 11.4474C11.1225 11.0184 12.871 9.17721 11.1494 7.50082C9.62741 6.01888 8.82121 5.62183 7.12788 7.29533C6.28999 8.12347 5.93323 8.79183 6.24942 10.46C6.46724 11.6093 6.84583 12.6666 7.31027 13.6185C9.08773 17.2624 13.079 20.342 17.1435 20.742C18.8737 20.9124 19.3629 20.4629 20.2522 19.5758C22.1371 17.6954 19.1848 14.7275 17.3795 15.3555C16.1679 15.777 15.632 17.2013 15.3267 17.5083H15.3266Z",
    fill: "#065697"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.5be2e7363dce8fb903125c5f53eca739.svg";
export { ForwardRef as ReactComponent };